exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form[data-v-4d479a5e]{padding:36px 27px 16px 36px;background-color:#f3f3f3;border-radius:4px}.form__buttons[data-v-4d479a5e],.form__fields[data-v-4d479a5e]{margin-bottom:27px;display:-ms-grid;display:grid;row-gap:18px}@media screen and (min-width:641px){.form__buttons[data-v-4d479a5e]{-ms-grid-columns:(1fr)[2];grid-template-columns:repeat(2,1fr);column-gap:27px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d479a5e","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/vacancies/form/components/requestform/RequestForm.vue
// module id = a065b8bd1f851b46a786
// module chunks = 0